import { CircleCheckIcon as CheckCircled } from '@air/design-icons';
import { type ToastOptions } from '@air/provider-toast';

type StandardToastOptions = Extract<ToastOptions, { CustomContainer?: never }>;

/** Frame.io-style import success: pinned top, manual dismiss, green circled check. */
export const importSuccessToastOptions = (overrides?: Partial<StandardToastOptions>): StandardToastOptions => ({
  color: 'black',
  placement: 'top',
  prefix: <CheckCircled className="shrink-0 text-success-9" size="sm" />,
  timeBeforeAutoDismiss: null,
  withCloseButton: true,
  ...overrides,
});

/** Partial batch success — top bar, manual dismiss, no success icon. */
export const importPartialSuccessToastOptions = (overrides?: Partial<StandardToastOptions>): StandardToastOptions => ({
  color: 'black',
  placement: 'top',
  timeBeforeAutoDismiss: null,
  withCloseButton: true,
  ...overrides,
});
